"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ACCOUNTING", {
  enumerable: true,
  get: function get() {
    return _Category.ACCOUNTING;
  }
});
Object.defineProperty(exports, "PAYROLL", {
  enumerable: true,
  get: function get() {
    return _Category.PAYROLL;
  }
});

var _Category = require("../Category");


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/groupTags/superCategoryGroups/Finance.js
// module id = 592
// module chunks = 209 210 211 212 213